import styled from 'styled-components';

export const DisabledContent = styled.span`
  opacity: ${({ isDisabled }) => isDisabled && 0.4} !important;
  pointer-events: ${({ isPointerEnabled }) => !isPointerEnabled && 'none'};
`;
